"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-input", {
    ref: "inputRef",
    staticClass: "trigger",
    attrs: {
      value: _vm.selectedValueText,
      placeholder: "点击选择部门或人员"
    },
    on: {
      click: _vm.handleClick
    }
  }, [_c("a-icon", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.modelValue,
      expression: "modelValue"
    }],
    staticClass: "clear-icon",
    attrs: {
      slot: "suffix",
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: _vm.handleClear
    },
    slot: "suffix"
  })], 1), _c("UserSelectModel", _vm._b({
    ref: "userSelectModalRef",
    attrs: {
      visible: _vm.visible
    },
    on: {
      "update:visible": function ($event) {
        _vm.visible = $event;
      },
      confirm: _vm.handleConfirm
    }
  }, "UserSelectModel", _vm.selectModalProps, false))], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;